module.exports = __webpack_public_path__ + "static/media/favicon-our-time.951456b3.ico";